// supabase.functions.invoke no lee el cuerpo de una respuesta 4xx/5xx: su error solo dice "Edge
// Function returned a non-2xx status code" y deja la respuesta en error.context. Las funciones del
// panel de admin explican el motivo en { error } (demasiadas solicitudes, acceso bloqueado tras
// varios códigos incorrectos...), así que se lee de ahí.
export async function functionErrorMessage(error: unknown): Promise<string | null> {
  const response = (error as { context?: unknown } | null)?.context;
  if (!(response instanceof Response)) return null;
  try {
    const body = await response.clone().json();
    return typeof body?.error === "string" && body.error.trim() !== "" ? body.error : null;
  } catch {
    return null;
  }
}
